var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.disabled)?_c('router-link',{attrs:{"id":_vm.idPosition,"to":{ name: _vm.to }}},[_vm._t("default")],2):_c('router-link',{staticClass:"bg-secondary",attrs:{"id":_vm.idPosition,"to":{ name: 'access-denied' }}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }